import { __assign, __awaiter, __generator } from "tslib";
import { performChallenge } from './worldpay-challenge';
import { logTaggedMessage } from '../../reporter';
var log = logTaggedMessage({
    module: '3ds',
    sub_module: 'worldpay_v1fallback',
});
export var performV1Fallback = function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var data, methodUrl, notificationUrl, provider, result, challengeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = action.data, methodUrl = action.methodUrl, notificationUrl = action.notificationUrl, provider = action.provider;
                return [4 /*yield*/, performChallenge({
                        data: data,
                        methodUrl: methodUrl,
                        notificationUrl: notificationUrl,
                        provider: provider,
                    }, log)];
            case 1:
                result = _a.sent();
                challengeData = result.challengeData;
                res = {
                    v1FallbackData: __assign({}, challengeData),
                };
                return [2 /*return*/, res];
        }
    });
}); };
//# sourceMappingURL=worldpay-v1fallback.js.map